import ArrowUpIcon from '../../atoms/icons/arrowUp';
import Container from '../../atoms/container/parentalPinDialUpContainer';
import { ParentalPinDialIconProps as Props } from '../../../../shared/types/props/parentalPin';

function ParentalPinDialUp({ callback }: Props) {
  return (
    <Container onClick={() => callback && callback()}>
      <ArrowUpIcon />
    </Container>
  );
}

export default ParentalPinDialUp;
